import { IcdOfficeListResponse, IcdOfficeModel, IcdCorporationResponse } from "@herbjoy/apex-api-models";
import { IComponentOptions, IFormController, IPromise } from "angular";
import { EventEmitter } from "../../../common/components/event-emitter";
import templateUrl from "./move-meridian-id-modal.component.html";
import { MeridianIdMovementService } from "./meridian-id-movement.service";

interface MeridianIdMovementRequestVM {
    targetIcdOffice: IcdOfficeListResponse;
}

/** The output event for movement submission. */
export interface MeridianIdMovementSubmitted {
    icdOfficeID: number;
}

/**
 * A component displaying a form used to move a Meridian ID from one office to another.
 */
export const MoveMeridianIdModalComponent: IComponentOptions = {
    templateUrl,
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controller: class MoveMeridianIdComponent {
        //@Input
        resolve: any = {};
        close: EventEmitter<{ $value: any }>;
        dismiss: EventEmitter<{ $value: any }>;
        editForm: IFormController;
        request: MeridianIdMovementRequestVM;
        icdCorporation: IcdCorporationResponse;
        /** The office from which the Meridian ID will be removed. */
        icdOffice: IcdOfficeModel;
        /** Event Emitter to which the submission will be sent. */
        submit: ($event: MeridianIdMovementSubmitted) => IPromise<void>;
        /** A list of offices that can be selected as the target. */
        targetIcdOffices: IcdOfficeListResponse;
        targetIcdOfficeValidationMessages: string[];

        constructor(private meridianIdMovementService: MeridianIdMovementService) {
            'ngInject';
        }

        $onInit() {
            this.icdCorporation = this.resolve.icdCorporation;
            this.icdOffice = this.resolve.icdOffice;
            this.targetIcdOffices = this.resolve.targetIcdOffices;
            this.submit = this.resolve.onSubmit;
            this.request = {
                targetIcdOffice: null
            };
        }

        onChangeTargetOffice() {
            // Set pending
            this.editForm.targetIcdOffice.$setValidity("valid-target")
            this.meridianIdMovementService.validateTargetIcdOffice(this.icdOffice.Id, this.request.targetIcdOffice.Id)
                .then(validation => {
                    this.editForm.targetIcdOffice.$setValidity("valid-target", validation.isValid)
                    this.targetIcdOfficeValidationMessages = validation.messages;
                })
                .catch(ex => {
                    console.error("Error occurred during validation", ex);
                    this.editForm.targetIcdOffice.$setValidity("valid-target", false)
                    this.targetIcdOfficeValidationMessages = ["Error - please try again"];
                });
        }
    }
};

/**
 * Default config options for displaying a Move Meridian ID modal.
 */
export const MoveMeridianIdModal = {
    component: "apexMoveMeridianIdModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'sm',
    backdrop: 'static'
}
